exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header{\n  background: rgb(45,200,187);\n  color: white;\n  font-size: 15px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/hihoo/ibilling/attendence/public/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = 1